import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Table } from "antd";
import { ContentBlockerField, EUserRole, TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useRuleColumns, useRuleDisplayColumns } from "./rules/columns.js";
import { RuleTable } from "./rules/rule-table.js";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldContentBlockerTemplateRules() {
    const { t } = useTranslation();
    const ruleColumns = useRuleColumns(t);
    const displayColumnDefinition = useRuleDisplayColumns(t);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: ContentBlockerField.Rules,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_CONTENT_BLOCKER_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(ContentBlockerField.Rules, t),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier,
            required: true,
            rules: [
                {
                    type: "array",
                    min: 1,
                    message: t("Please provide at least one URL/element!")
                }
            ],
            children: ({ getFieldValue })=>{
                const extended = getFieldValue(TemplateMetaDataField.Extends);
                return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                    extendsFieldName: ContentBlockerField.Rules,
                    disableStrategies: getDisableStrategies(true),
                    onKeepContent: extended && /*#__PURE__*/ _jsx(Table, {
                        rowKey: "id",
                        pagination: false,
                        dataSource: extended[ContentBlockerField.Rules],
                        columns: displayColumnDefinition
                    }),
                    children: /*#__PURE__*/ _jsx(RuleTable, {
                        formName: ContentBlockerField.Rules,
                        columns: ruleColumns
                    })
                });
            }
        })
    });
}
export { FormFieldContentBlockerTemplateRules };
